import axios from "axios";
import { toast } from "react-toastify";
import authHeader from "./auth-header";

export const fetchAllOrderPrintFormats = (filters = {}) => {
  const query_string = new URLSearchParams(filters).toString();
  return axios
    .get(`${process.env.REACT_APP_BASE_URL}/ordprintformat?${query_string}`, {
      headers: authHeader(),
    })
    .then((res) => {
      // toast.success(res.data.msg);
      return res.data.data;
    })
    .catch((err) => {
      toast.error(err?.response?.data?.msg);
      throw err;
    });
};
